module.exports = __webpack_public_path__ + "static/betterers-duo-ea188296967b43bbc3a00768f2fc1f19.png";